/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BalanceLimit = {
    has2faLimit?: boolean;
    isUnlimited?: boolean;
    limit?: number;
    limit2FA?: number;
    type?: BalanceLimit.type;
};

export namespace BalanceLimit {

    export enum type {
        PER_TRANSACTION = 'PER_TRANSACTION',
        PER_DAY = 'PER_DAY',
        PER_MONTH = 'PER_MONTH',
        BALANCE = 'BALANCE',
    }


}
